import * as React from 'react';
import { MapContainer } from '../../containers/Map';
import * as style from './Infrastructure.css';
import { SpecialPromoLinkContainer } from '../../containers/SpecialPromoLink';
import { NearbyNewbuildingsLinkContainer } from '../../containers/NearbyNewbuildingsLink';
import { LayoutBlock } from '../LayoutBlock';
import { Section } from '../Section';

export const Infrastructure: React.FC = () => {
  return (
    <LayoutBlock>
      <Section data-nav-tab="infrastructure/Инфраструктура" id="infrastructure">
        <div className={style['content']}>
          <span className={style['header']}>
            <SpecialPromoLinkContainer />
            <NearbyNewbuildingsLinkContainer />
          </span>
          <MapContainer />
        </div>
      </Section>
    </LayoutBlock>
  );
};
